import styled from 'styled-components';

export const CLAIM_REQUEST_REASONS = ['고객 요청', '단순 변심', '상품 불량', '오배송', '배송 지연', '재고 부족'];
export const CLAIM_REJECTION_REASONS = ['주문 정보 확인 필요', '상품 상태 확인 필요', '요청 수량 확인 필요', '추가 자료 확인 필요'];

export default function ClaimReasonPresets({ reasons, value, onChange, disabled, label }: {
  reasons: string[]; value: string; onChange: (value: string) => void; disabled?: boolean; label: string;
}) {
  return <Presets role="group" aria-label={label}>{reasons.map(reason => <button key={reason} type="button"
    aria-pressed={reason === value} disabled={disabled} onClick={() => onChange(reason)}>{reason}</button>)}</Presets>;
}

const Presets = styled.div`
  display: flex; flex-wrap: wrap; gap: var(--space-2); margin-block: var(--space-2);
  button { min-height: var(--control-md); padding: 0 var(--space-3); border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md); background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; cursor: pointer; }
  button[aria-pressed="true"] { background: var(--color-brand-subtle); border-color: var(--color-brand); color: var(--color-text-link); }
  button:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: default; }
  button:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { button { min-height: var(--touch-target); } }
`;
